import { render, staticRenderFns } from "./PerSalary.vue?vue&type=template&id=74c6aea7&scoped=true&"
import script from "./PerSalary.vue?vue&type=script&lang=js&"
export * from "./PerSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c6aea7",
  null
  
)

export default component.exports